// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3cb97a70","337":"3ced6c6f","453":"c978ec56","455":"ecf2a3dd"}[chunkId] + ".chunk.js";
};